import { render, staticRenderFns } from "./_base-info-side-details-interact-activity-historical.vue?vue&type=template&id=57d890a1&"
import script from "./_base-info-side-details-interact-activity-historical.vue?vue&type=script&lang=js&"
export * from "./_base-info-side-details-interact-activity-historical.vue?vue&type=script&lang=js&"
import style0 from "./_base-info-side-details-interact-activity-historical.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports